import { memo } from 'react';
import { DialogContent } from '@radix-ui/react-dialog';
import { SwitchCase } from '@toss/react';
import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUserPlanManager } from '@/shared/plan';
import { useUpsellingGuard } from '@/shared/plan/useUpsellingGuard';
import { Dialog, DialogOverlay, DialogPortal } from '@/ui_v3';
import { cn } from '@/utils';
import { DesktopTrigger } from './DesktopTrigger';
import { Header } from './Header';
import { Pending } from './Pending';
import { SimilarQuizPrompt } from './SimilarQuizPrompt';
import { Success } from './Success';
import { type AiGenerateSimilarQuizModalProps } from './type';
export const Modal = memo((props: AiGenerateSimilarQuizModalProps) => {
  const {
    disabled,
    isOpen,
    onOpen,
    onClose,
    className,
    prompt,
    items,
    onRetry,
    status,
    promptPresets,
    previousPrompt,
    onGetPromptPresets,
    onGenerate,
    onDelete
  } = props;
  const {
    userPlanManager
  } = useUserPlanManager();
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_SIMILAR_QUIZ_GENERATION');
  const upsellingGuard = useUpsellingGuard();
  return <Dialog open={isOpen}>
      <WithPlanBadge isBadgeVisible={true} planType={featurePlanType}>
        <DesktopTrigger disabled={disabled} onClick={() => upsellingGuard(() => onOpen(), {
        feature: 'AI_SIMILAR_QUIZ_GENERATION',
        from: 'ai'
      })} className={className} />
      </WithPlanBadge>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent onInteractOutside={e => e.preventDefault()} className={cn('w-full mobile-lg:w-[720px]', 'overflow-hidden max-h-[calc(90%-env(safe-area-inset-top))] max-w-[calc(100vw-32px)] mobile-lg:max-w-[calc(100vw-48px)] tablet-lg:max-w-[calc(100vw-80px)] flex flex-col', 'rounded-md fixed left-[50%] top-[50%] z-modal w-full translate-x-[-50%] translate-y-[-50%] shadow-xl bg-white p-0 duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]', 'shadow-2xl h-[750px]')}>
          <Header onClose={onClose} />
          <SwitchCase value={status} caseBy={{
          pending: <Pending prompt={prompt} />,
          success: <Success items={items} onRetry={onRetry} onClose={onClose} onDelete={onDelete} />
        }} defaultComponent={<SimilarQuizPrompt onMount={onGetPromptPresets} onGenerate={onGenerate} onCancel={onClose} previousPrompt={previousPrompt} promptPresets={promptPresets} />} />
        </DialogContent>
      </DialogPortal>
    </Dialog>;
});